
import { NodeFilterActions, NodeFilterActionTypes } from '../actions/node-filter.actions';

export interface State {
  RegionId: number;
}

export const initialState: State = {
  RegionId: 1
};

export function reducer(state = initialState, action: NodeFilterActions): State {
  switch (action.type) {

    case NodeFilterActionTypes.LoadNodeFilters:
      return {...state, RegionId: action.payload.RegionId};

    default:
      return state;
  }
}
